import { constants } from '@bingads-webui-campaign-react/image-experience-model';
import { getAutoCroppedImages } from '@bingads-webui-campaign-react/image-experience';

import { IMTAsset, IImageMapUrl } from './types';

export function getLogoExperience(assets: IMTAsset[], imageToUrlMap: IImageMapUrl) {
  const logoGroup = Object.keys(imageToUrlMap);

  // ImageToUrlMap contains distinct ids, while assets could contain multiple assets with same id
  return assets.filter(ass => logoGroup.includes(ass.IdString)).map((asset) => {
    const key = asset.IdString;
    const assetExtraInfo = imageToUrlMap[key];

    return getAutoCroppedImages({
      originalImageToCrop: {
        Id: `${key}-${asset.SubType}`,
        IdString: key,
        Src: imageToUrlMap[key].url,
        Width: imageToUrlMap[key].width,
        Height: imageToUrlMap[key].height,
        source: imageToUrlMap[key].sourceType,
      },
      imageOption: constants.imageOptionKeys.Logo,
      aspectRatioOption: constants.logoSubtypes[asset.SubType],
      isMultimediaAdinMSANEnabled: true,
      maxCropBox: {
        SourceX: asset.CropX ? asset.CropX : 0,
        SourceY: asset.CropY ? asset.CropY : 0,
        SourceWidth: asset.CropWidth ? asset.CropWidth : assetExtraInfo.width,
        SourceHeight: asset.CropHeight ? asset.CropHeight : assetExtraInfo.height,
      },
    });
  });
}
